import React from 'react'
import UpdateEnergyBreadCrumb from './UpdateEnergyBreadCrumb';
import UpdateRenewableEnergy from './UpdateRenewableEnergy';
function UpdateRenewableEnergyPage() {
    return ( 
        <>
            <UpdateEnergyBreadCrumb />
            <UpdateRenewableEnergy />

        </>
     );
}

export default UpdateRenewableEnergyPage;